var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMedalBadgeIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#medal-badge-icon_svg__clip0_23948_49579)",
    stroke: "#E95832",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.999 10a4.667 4.667 0 100-9.334 4.667 4.667 0 000 9.334z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.475 9.26l-.807 6.073 3.333-2 3.334 2-.807-6.08"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "medal-badge-icon_svg__clip0_23948_49579"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h16v16H0z"
  })))));
}
export default __webpack_public_path__ + "static/media/medal-badge-icon.048288b6.svg";
export { SvgMedalBadgeIcon as ReactComponent };